/* eslint-disable eslint-comments/disable-enable-pair -- skeleton */
/* eslint-disable @typescript-eslint/no-deprecated -- skeleton */
import { Skeleton } from "@tql/ui-components-react/kendo/indicators";

import type { Terminal } from "~/shared/schemas/terminal-schema";

type ExpansionSectionProps = {
	terminal: Terminal | undefined;
	isLoading: boolean;
	type: "Origin" | "Destination";
};

export const ExpansionSection = ({
	terminal,
	isLoading,
	type,
}: ExpansionSectionProps) => {
	const terminalContent = terminal ? (
		<div>
			<div className={"expansion-field"}>
				<div className={"expansion-col-title"}>Name</div>
				<div>
					{terminal?.terminalName}
					{terminal?.code ? ` [${terminal.code}]` : null}
				</div>
			</div>
			<div className={"expansion-field"}>
				<div className={"expansion-col-title"}>Address</div>
				<div>
					{terminal?.address1}
					{terminal?.address2 ? `, ${terminal.address2}` : ""}
					<br />
					{terminal?.city}, {terminal?.stateProvince} {terminal?.postalCode}
				</div>
			</div>
			<div className={"expansion-field"}>
				<div className={"expansion-col-title"}>Phone</div>
				<div>{terminal?.contact.phone}</div>
			</div>
			<div className={"expansion-field"}>
				<div className={"expansion-col-title"}>Toll Free Phone</div>
				<div>{terminal?.contact.tollFree}</div>
			</div>
		</div>
	) : (
		<div>
			<i>No terminal information found.</i>
		</div>
	);

	return (
		<div className={"expansion-section"}>
			<div className={"expansion-title"}>
				{type === "Destination" ? (
					<>
						<span className={"expansion-title-full"}>Destination Terminal</span>
						<span className={"expansion-title-abbr"}>Dest. Terminal</span>
					</>
				) : (
					`${type} Terminal`
				)}
			</div>
			<div
				className={`expansion-details ${isLoading ? "loading" : null}`}
				data-testid={"expansion-details"}
			>
				{isLoading ? (
					<Skeleton
						shape={"rectangle"}
						style={{ width: "100%", height: 100 }}
					/>
				) : (
					terminalContent
				)}
			</div>
		</div>
	);
};
